module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "tabelaBox",
    attrs: {
      "grid-list-sm": "",
      "grid-list-md": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md8": ""
    }
  }, [_c('h5', [_vm._v("\n        Seu negócio\n      ")]), _vm._v(" "), _c('p', [_vm._v("Selecione uma categoria de interesse para fornecer seus produtos e/ou serviços")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md7": ""
    }
  }, [_c('div', {
    class: _vm.sugestao ? 'input-search disabled' : 'input-search'
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("search")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisar),
      expression: "pesquisar"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "value": "",
      "placeholder": "Procurar",
      "disabled": _vm.sugestao
    },
    domProps: {
      "value": (_vm.pesquisar)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pesquisar = $event.target.value
      }
    }
  })], 1)])], 1), _vm._v(" "), (!(_vm.filtroClasseSugerida === false || _vm.filtroClasseSugerida === [])) ? [_c('div', {
    staticClass: "mt-4"
  }, [_c('v-layout', {
    staticClass: "chips-selecionados",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "font-red pa-3 espacamento"
  }, [_vm._v("Categoria"), (_vm.filtroClasseSugerida.categoriasLista.length !== 1) ? _c('span', [_vm._v("s")]) : _vm._e(), _vm._v(" escolhida"), (_vm.filtroClasseSugerida.categoriasLista.length !== 1) ? _c('span', [_vm._v("s")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.chipsSelecionadas), function(chip) {
    return _c('v-chip', {
      key: chip.id,
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.removeCategoria(chip.id)
        }
      }
    }, [_vm._v(_vm._s(chip.name))])
  })], 2)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-1 pb-2",
    staticStyle: {
      "border-bottom": "1px solid #d7d7d7"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "link",
    on: {
      "click": _vm.resetarCategorias
    }
  }, [_vm._v("\n            Quero pesquisar novamente\n          ")])])], 1), _vm._v(" "), (!_vm.sugestao) ? _c('v-layout', {
    staticClass: "mt-3 mb-3",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n          Encontramos "), _c('strong', [(_vm.filtroClasseSugerida.categoriasLista.length < 10) ? _c('span', [_vm._v("0")]) : _vm._e(), _vm._v(_vm._s(_vm.filtroClasseSugerida.categoriasLista.length) + " Categoria"), (_vm.filtroClasseSugerida.categoriasLista.length !== 1) ? _c('span', [_vm._v("s")]) : _vm._e()]), _vm._v(" semelhante"), (_vm.filtroClasseSugerida.categoriasLista.length !== 1) ? _c('span', [_vm._v("s")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.sugestao = !_vm.sugestao
      }
    }
  }, [_vm._v("visualizar")])])], 1) : _c('v-layout', {
    staticClass: "mt-3 mb-3",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.sugestao = !_vm.sugestao
      }
    }
  }, [_vm._v("Voltar a pesquisa")])])], 1)], 1)] : _vm._e(), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-sm": "",
      "grid-list-md": "",
      "text-xs-center": "",
      "fluid": ""
    }
  }, [_vm._l((_vm.fitroClasse), function(classe, i) {
    return [_c('v-layout', {
      key: i,
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "text-xs-left",
      attrs: {
        "xs12": "",
        "mt-3": ""
      }
    }, [_c('div', [_vm._v(_vm._s(classe.nome))])]), _vm._v(" "), _vm._l((classe.categoriasLista), function(categoria, index) {
      return [_c('transition', {
        key: index,
        attrs: {
          "name": "fade"
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "sm6": "",
          "md4": ""
        }
      }, [_c('div', {
        staticClass: "box"
      }, [(categoria.name.length > 27) ? _c('v-tooltip', {
        attrs: {
          "top": ""
        }
      }, [_c('template', {
        slot: "activator"
      }, [_c('v-checkbox', {
        staticStyle: {
          "width": "90%"
        },
        attrs: {
          "label": categoria.name,
          "value": categoria.id
        },
        model: {
          value: (_vm.classeSelecionada),
          callback: function($$v) {
            _vm.classeSelecionada = $$v
          },
          expression: "classeSelecionada"
        }
      })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(categoria.name))])], 2) : [_c('v-checkbox', {
        staticStyle: {
          "width": "90%"
        },
        attrs: {
          "label": categoria.name,
          "value": categoria.id
        },
        model: {
          value: (_vm.classeSelecionada),
          callback: function($$v) {
            _vm.classeSelecionada = $$v
          },
          expression: "classeSelecionada"
        }
      })]], 2)])], 1)]
    })], 2)]
  })], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d2d94a60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabelaClasses/index.vue
// module id = 774
// module chunks = 5